import { useRoute } from 'vue-router';

// FIXME: 共通関数に特定のdomainを入れない。tracking処理が整理されていないため必要な状態。
export function useCurrentPathForTracking() {
  const route = useRoute();

  /**
   * 現在のパスを取得する。計測用の関数
   * @returns {string} 現在のルートのパス
   *
   * WARNING: クエリパラメータが不要な場合は、無闇にroute.fullPathを使わないこと。
   * 現在Anewsでは社内情報に関するデータを扱っており、クエリパラメータが機微な情報にあたる可能性がある（要約メニュー、 社内情報検索機能など）。
   * そのため、計測において基本は`route.path`を使用し、`route.fullPath`を使用する場合は影響範囲をしっかり調査した上で機微情報が漏れないように注意すること。
   */
  const getCurrentPathForTracking = (): string => {
    const keywords = ['/surveys/', '/search/'];
    return keywords.some(keyword => route.path.includes(keyword))
      ? route.path
      : route.fullPath;
  };

  return { getCurrentPathForTracking };
}
